import { createSlice } from "@reduxjs/toolkit";

export enum RefurbishedStorageEnum {
    COACHMARK_CLOSED = "refurbished_coachmark_closed",
}

export interface RefurbishedPageInterface {
    isCoachMarkVisible: boolean;
    selectedFilters: Record<string, string[]>;
}

const initialState: RefurbishedPageInterface = {
    isCoachMarkVisible:
        localStorage.getItem(RefurbishedStorageEnum.COACHMARK_CLOSED) !==
        "true",
    selectedFilters: {},
};

const refurbishedSlice = createSlice({
    name: "refurbished",
    initialState,
    reducers: {
        setIsCoachMarkVisible: (state, action) => {
            state.isCoachMarkVisible = action.payload;
        },
        setSelectedFilters: (state, action) => {
            state.selectedFilters = action.payload;
        },
    },
});

export const refurbishedReducer = refurbishedSlice.reducer;
export const { setIsCoachMarkVisible, setSelectedFilters } =
    refurbishedSlice.actions;
